import { render, staticRenderFns } from "./Prescription.vue?vue&type=template&id=154a668c&"
import script from "./Prescription.vue?vue&type=script&lang=ts&"
export * from "./Prescription.vue?vue&type=script&lang=ts&"
import style0 from "./Prescription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports